const overloading = {
  breakpointNames: ['sm', 'md', 'lg', 'xl', 'xxl'],
  breakpoints: [576, 768, 992, 1200, 1600]
}

const colors = {
  colorBlue: '#002c72',      // Brand blue (headings, links, buttons, hamburger)
  colorLtBlue: '#689aca',    // Light blue (hover / secondary)
  colorBlack: '#000000',
  colorWhite: '#ffffff'
}

const variables = {
  familyBase: '"proxima-nova", sans-serif',    // Adobe Typekit kit isp7qsr
  familyHeader: '"proxima-nova", serif',       // matches $family-header in _variables.scss

  primaryColor: colors.colorBlue,
  secondaryColor: colors.colorLtBlue,
  fontColor: colors.colorBlack,
  bgColor: colors.colorWhite,

  ...colors,
  ...overloading
}

export default variables;
